import React, { useEffect, useState } from 'react';
import { Animated, Easing, StyleSheet, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { isWeb } from 'shared/constants/platform';
import theme from 'shared/styles/theme';

interface LoadingSpinnerProps {
  fill?: string;
  accessibilityLabel?: string;
}

const LoadingSpinner = ({
  fill = theme.color.text.muted,
  accessibilityLabel = 'loading indicator',
}: LoadingSpinnerProps) => {
  const [spinValue] = useState(new Animated.Value(0));

  useEffect(() => {
    const spinAnimation = Animated.loop(
      Animated.timing(spinValue, {
        toValue: 1,
        duration: 1000,
        easing: Easing.linear,
        useNativeDriver: !isWeb, // Native driver not supported on web
      }),
    );

    spinAnimation.start();

    return () => {
      spinAnimation.stop();
    };
  }, [spinValue]);

  const spin = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });

  return (
    <View style={styles.container}>
      <Animated.View
        style={[styles.animatedContainer, { transform: [{ rotate: spin }] }]}
        accessible
        accessibilityLabel={accessibilityLabel}
      >
        <Svg viewBox="0 0 24 24" fill="none" style={styles.svg}>
          <Path
            d="M12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12H20C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4V5.77778Z"
            fill={fill}
          />
        </Svg>
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  animatedContainer: {
    height: '100%',
    width: '100%',
  },
  container: {
    height: 24,
    overflow: 'hidden',
    width: 24,
  },
  svg: {
    height: '100%',
    width: '100%',
  },
});

export default LoadingSpinner;
